import SearchBar from "components/layout/searchbar"

export default ({}) => (
	<>
		<h2 className="overlay-title">Recherche</h2>
		<SearchBar />
	</>
)
